module.exports = [
  {
    label: 'ヒーロー',
    value: 'hero'
  },
  {
    label: 'ダークナイト',
    value: 'darknight'
  },
  {
    label: 'パラディン',
    value: 'paladin'
  },
  {
    label: 'アークメイジ(氷、雷)',
    value: 'ice'
  },
  {
    label: 'ビショップ',
    value: 'bishop'
  },
  {
    label: 'ボウマスター',
    value: 'bowmaster'
  },
  {
    label: 'クロスボウマスター',
    value: 'crossbowmaster'
  },
  {
    label: 'ナイトロード',
    value: 'nightload'
  },
  {
    label: 'シャドー',
    value: 'shadow'
  },
  {
    label: 'バイパー',
    value: 'viper'
  },
  {
    label: 'キャプテン',
    value: 'captain'
  },
  {
    label: 'ソウルマスター',
    value: 'soulmaster'
  },
  {
    label: 'フレイムウィザード',
    value: 'framewizard'
  },
  {
    label: 'ウィンドシューター',
    value: 'windshooter'
  },
  {
    label: 'ナイトウォーカー',
    value: 'nightwalker'
  },
  {
    label: 'ストライカー',
    value: 'striker'
  },
  {
    label: 'アラン',
    value: 'alan'
  }
]
